import WorkBlockFromSidebar from "components/common/Scheduler/SchedulerRenderers/components/blocks/WorkBlockFromSidebar";
import React from "react";
import renderToString from "./renderToString";

export default function workOrderDraggedRenderer({ dragWorkOrder, dragApplicationContext }) {
  return renderToString(
    <WorkBlockFromSidebar
      dragApplicationContext={dragApplicationContext}
      dragWorkOrder={dragWorkOrder}
      schedule={this.schedule}
    />,
  );
}
